
        import 'CardElements.e19564b.css-module'
        export default {"focus":"focus_CardElements_e19564b"}
    